// GPS Types - Centralized TypeScript definitions for TrackingONE

export interface GpsDevice {
  id: string;
  company_id: string;
  code: string;
  imei_or_uid?: string;
  model?: string;
  protocol?: string;
  server?: 'traccar' | 'owntracks';
  sim_iccid?: string;
  chip_operator?: 'tim' | 'claro' | 'vivo' | 'm2m';
  vehicle_id?: string;
  status: 'moving' | 'idle' | 'offline' | 'sleep' | 'unknown';
  battery_level?: number;
  last_signal_at?: string;
  latitude?: number;
  longitude?: number;
  speed_kmh?: number;
  ignition?: boolean;
  created_at: string;
  updated_at: string;
  vehicle_plate?: string;
  vehicle_make?: string;
  vehicle_model?: string;
}

export interface GpsCommand {
  id: string;
  company_id: string;
  device_id: string;
  command_type: string;
  payload: Record<string, any>;
  status: 'pending' | 'sent' | 'ack' | 'failed';
  sent_at?: string;
  ack_at?: string;
  error_message?: string;
  created_by?: string;
  created_at: string;
  updated_at: string;
}

export interface GpsNotificationLog {
  id: string;
  company_id: string;
  device_id?: string;
  type: 'webhook' | 'email' | 'telegram';
  event_type: string;
  payload: Record<string, any>;
  status: 'success' | 'failed' | 'pending';
  retries: number;
  error_message?: string;
  created_at: string;
  delivered_at?: string;
}

export interface GpsUserPermissions {
  id: string;
  company_id: string;
  user_id: string;
  can_view_live: boolean;
  can_view_history: boolean;
  history_days_limit?: number;
  can_send_commands: boolean;
  can_edit_devices: boolean;
  can_view_reports: boolean;
  can_share_tracking: boolean;
  created_at: string;
  updated_at: string;
}

export interface GpsPosition {
  id: string;
  device_id: string;
  latitude: number;
  longitude: number;
  altitude?: number;
  speed_kmh?: number;
  heading?: number;
  accuracy?: number;
  battery_level?: number;
  signal_strength?: number;
  recorded_at: string;
  created_at: string;
}

export const GPS_COMMAND_TYPES = {
  ENGINE_STOP: 'engine_stop',
  ENGINE_RESUME: 'engine_resume',
  POSITION_SINGLE: 'position_single',
  REBOOT: 'reboot',
  SET_UPDATE_INTERVAL: 'set_update_interval',
  CUSTOM: 'custom',
} as const;
